export default __webpack_public_path__ + "static/demo-video-720-aebfa33fbd6ed1aa36958b6cfd4aab6a.mp4";